
export enum BankAccountMemberOperations {
    NONE = 0,
    VIEW = 1,
    CHANGE_ROLE = 2,
    DELETE = 4,
}
